const { Dropbox } = require('dropbox');

let Uploaders = {};
Uploaders.DropboxUploader = function (entries) {
  entries.forEach(entry => {
    let { file, meta } = entry;
    var dbx = new Dropbox({ accessToken: meta.access_token });
    const sessionId = meta.session_id;
    const maxBlob = 50 * 1024 * 1024; // Dropbox JavaScript API suggested chunk size
    var workItems = [];
    var offset = 0;
    while (offset < file.size) {
      var chunkSize = Math.min(maxBlob, file.size - offset);
      workItems.push(file.slice(offset, offset + chunkSize));
      offset += chunkSize;
    }
    var percent_batch = 100 / workItems.length;
    const task = workItems.reduce((acc, blob, idx, items) => {
      // Append part to the upload session
      return acc.then(function () {
        var cursor = { session_id: sessionId, offset: idx * maxBlob };
        entry.progress(idx * percent_batch);
        return dbx.filesUploadSessionAppendV2({ cursor: cursor, close: false, contents: blob }).then(() => sessionId);
      });
    }, Promise.resolve());

    task
      .then(function (result) {
        entry.progress(100);
      })
      .catch(function (error) {
        console.error(error);
      });
  });
};

Uploaders.GCSUploader = function (entries, onViewError) {
  entries.forEach(entry => {
    let formData = new FormData();
    let { url } = entry.meta;
    let xhr = new XMLHttpRequest();
    onViewError(() => xhr.abort());
    xhr.onload = () => (xhr.status === 200 ? entry.progress(100) : entry.error());
    xhr.onerror = () => entry.error();
    xhr.upload.addEventListener('progress', event => {
      if (event.lengthComputable) {
        let percent = Math.round((event.loaded / event.total) * 100);
        if (percent < 100) {
          entry.progress(percent);
        }
      }
    });

    xhr.open('PUT', url, true);
    xhr.send(entry.file);
  });
};

// Mux direct uploads accept the whole file as a single PUT to the signed URL.
Uploaders.MuxUploader = function (entries, onViewError) {
  entries.forEach(entry => {
    let { url } = entry.meta;
    let xhr = new XMLHttpRequest();
    onViewError(() => xhr.abort());
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? entry.progress(100) : entry.error());
    xhr.onerror = () => entry.error();
    xhr.upload.addEventListener('progress', event => {
      if (event.lengthComputable) {
        let percent = Math.round((event.loaded / event.total) * 100);
        if (percent < 100) {
          entry.progress(percent);
        }
      }
    });

    xhr.open('PUT', url, true);
    xhr.send(entry.file);
  });
};

export default Uploaders;
